/**
 * Ряд значений одной строкой — там, где среднее врёт формой.
 *
 * Заведено ради восстановления: средняя скорость 18 МБ/с и ровный поток в
 * 18 МБ/с выглядят на приборе одинаково, а это разные вещи. Здесь видно, что
 * поток идёт толчками: столбик — пак приехал, провал — приёмник его
 * разбирает, и в это время не едет ничего.
 *
 * Столбиками, а не линией: линия между двумя нулями рисует наклон, которого
 * не было, и глаз читает его как «плавно нарастает».
 */
export function Sparkline({ values, height = 26, label }: {
  values: number[];
  height?: number;
  /** Что это за ряд — для тех, кто читает экран голосом. */
  label: string;
}): React.JSX.Element | null {
  if (values.length < 4) return null;

  const max = Math.max(...values, 1);
  const w = 2;
  const gap = 1;
  const width = values.length * (w + gap);

  return (
    <svg className="spark" viewBox={`0 0 ${width} ${height}`} role="img" aria-label={label}
         preserveAspectRatio="none">
      {values.map((v, i) => {
        const h = Math.max(1, (v / max) * (height - 2));
        return (
          <rect
            key={i}
            className={v < 1e6 ? 'spark__bar spark__bar--idle' : 'spark__bar'}
            x={i * (w + gap)} y={height - h} width={w} height={h} rx={0.6}
          />
        );
      })}
    </svg>
  );
}
